import Vue from 'vue'
import { Toast, Notify } from 'vant'

// 清除提示
Vue.prototype.$ClearTips = () => {
  Toast.clear()
  Notify.clear()
}
// 持续提示
Vue.prototype.$ContinueToast = (message) => {
  Toast.loading({
    duration: 100000000, // 持续展示 toast
    forbidClick: true, // 禁用背景点击
    overlay: true,
    closeOnClickOverlay: false,
    loadingType: 'spinner',
    message: message
  })
}

// 过滤日期格式，传入时间戳，根据参数返回不同格式
const formatTimer = function(val, hours) {
  if (val) {
    var dateTimer = new Date(val * 1000)
    var y = dateTimer.getFullYear()
    var M = dateTimer.getMonth() + 1
    var d = dateTimer.getDate()
    var h = dateTimer.getHours()
    var m = dateTimer.getMinutes()
    M = M >= 10 ? M : '0' + M
    d = d >= 10 ? d : '0' + d
    h = h >= 10 ? h : '0' + h
    m = m >= 10 ? m : '0' + m
    if (hours) {
      return y + '-' + M + '-' + d + ' ' + h + ':' + m
    } else {
      return y + '-' + M + '-' + d
    }
  }
}

export default {
  formatTimer
}



// WEBPACK FOOTER //
// ./src/filters/index.js